export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST';
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCCESS';
export const ORDER_CREATE_FAIL = 'ORDER_CREATE_FAIL';
export const ORDER_CREATE_RESET = 'ORDER_CREATE_RESET';

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';

export const QUOTE_REQUEST_START = 'QUOTE_REQUEST_START';
export const QUOTE_REQUEST_SUCCESS = 'QUOTE_REQUEST_SUCCESS';
export const QUOTE_REQUEST_FAIL = 'QUOTE_REQUEST_FAIL';

export const ORDER_PAY_REQUEST = 'ORDER_PAY_REQUEST';
export const ORDER_PAY_SUCCESS = 'ORDER_PAY_SUCCESS';
export const ORDER_PAY_FAIL = 'ORDER_PAY_FAIL';
export const ORDER_PAY_RESET = 'ORDER_PAY_RESET';

export const ORDER_MINE_LIST_REQUEST = 'ORDER_MINE_LIST__REQUEST';
export const ORDER_MINE_LIST_SUCCESS = 'ORDER_MINE_LIST__SUCCESS';
export const ORDER_MINE_LIST_FAIL = 'ORDER_MINE_LIST__FAIL';
export const ORDER_MINE_LIST_RESET = 'ORDER_MINE_LIST__RESET';
